import { z } from 'zod';

import { dayOfWeekSchema, isoDateSchema, timeOfDaySchema } from './primitives';

export const openingIntervalSchema = z.object({
  opensAt: timeOfDaySchema,
  closesAt: timeOfDaySchema,
  /** True iff the closesAt rolls into the next day (e.g. 02:00 close after 18:00 open). */
  closesNextDay: z.boolean().default(false),
});
export type OpeningInterval = z.infer<typeof openingIntervalSchema>;

export const dailyOpeningHoursSchema = z.object({
  dayOfWeek: dayOfWeekSchema,
  intervals: z.array(openingIntervalSchema),
});
export type DailyOpeningHours = z.infer<typeof dailyOpeningHoursSchema>;

export const openingHoursOverrideSchema = z.object({
  date: isoDateSchema,
  closed: z.boolean(),
  intervals: z.array(openingIntervalSchema).optional(),
  reason: z.string().max(280).optional(),
});
export type OpeningHoursOverride = z.infer<typeof openingHoursOverrideSchema>;
